import React from 'react';
import ReactDOM from 'react-dom';
import "normalize.css";
import './index.css';
import Cardapio from './pages/cardapio';

ReactDOM.render(
  <React.StrictMode>
    <Cardapio/>
  </React.StrictMode>,
  document.getElementById('root')
);